import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom"
import MainLayout from "@/pages/layouts/MainLayout"
import CustomerList from "@/pages/customers/CustomerList"
import Login from "./pages/authentication/Login"
import StoreList from "@/pages/stores/StoreList"
import CashDenominationList from "@/pages/cash-denominations/CashDenominationList"
import SupplierList from "@/pages/suppliers/SupplierList"
import ProductList from "@/pages/products/ProductList"
import ProductVariantList from "@/pages/variant-product/ProductVariantList"
import AttributeList from "@/pages/attributes/AttributeList"
import AttributeDetails from "@/pages/attributes/AttributeDetails"
import TagList from "@/pages/tags/TagList"
import OrderList from "@/pages/orders/OrderList"
import UserList from "@/pages/users/UserList"
import AuthRoutes from "./guards/AuthRoutes"
import GuestRoutes from "./guards/GuestRoutes"
import NotFound from "./pages/not-found"
import Logout from "./pages/authentication/Logout"
import UserDetails from "./pages/users/UserDetails"
import StoreDetails from "./pages/stores/StoreDetails"
import CustomerDetails from "./pages/customers/CustomerDetails"
import SupplierDetails from "@/pages/suppliers/SupplierDetails"
import TagDetails from "@/pages/tags/TagDetails"
import RoleList from "./pages/role/RoleList"
import StockTransactionList from "@/pages/stockTransaction/StockTransactionList"
import StockAdjustmentList from "@/pages/stock-adjustment/StockAdjustmentList"
import DamageProductsList from "@/pages/stockTransaction/DamageProductsList"
import OrderDetails from "./pages/orders/OrderDetails"
import VariantDetails from "./pages/variant-product/VariantDetails"
import ProductDetails from "./pages/products/ProductDetails"
import InvoiceDetails from "./pages/invoices/InvoiceDetails"
import AdjustmentDetails from "@/pages/stock-adjustment/AdjustmentDetails"
import Dashboard from "./pages/Dashboard"
import ActivityLogs from "./pages/system-logs/ActivityLogsList"
import PurchaseList from "./pages/purchase/PurchaseList"
import PaymentMethodsList from "./pages/payment-methods/PaymentMethodsList"
import ReasonList from "@/pages/reasons/ReasonList"
import SalesDashboard from "./pages/reports/SalesDashboard"
import PurchaseDetails from "./pages/purchase/PurchaseDetails"
import CustomerReturnList from "./pages/customer-returns/CustomerReturnList"
import AttributeNameList from "./pages/attribute-name/AttributeNameList"
import ProductDashboard from "./pages/reports/ProductDashboard"
import InventoryConfigurationPage from "./pages/inventory/InventoryConfigurationPage"
import SalesReturnList from "./pages/sales-return/SalesReturnList"
import CategoryList from "./pages/categories/CategoryList"
import CategoryDetails from "./pages/categories/CategoryDetails"
import { websiteRoutes } from "./pages/website/router"
import WebsiteOrderList from "./pages/website-orders/WebsiteOrderList"
import WebsiteOrderDetails from "./pages/website-orders/WebsiteOrderDetails"
import BrandList from "./pages/brand/BrandList"
import BrandDetails from "./pages/brand/BrandDetails"
import DenominationSettingList from "./pages/denomination-setting/DenominationSettingList"
import CurrencyNoteList from "./pages/currency-note-setting/CurrencyNoteList"
import ExpenseList from "./pages/expense/ExpenseList"
import CashDenominationDetails from "./pages/cash-denominations/CashDenominationDetails"
import WebsiteConfig from "./pages/website-config/WebsiteConfig"

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      {/* Website Routes */}
      {websiteRoutes}

      <Route element={<GuestRoutes />}>
        <Route path="/login" element={<Login />} />
      </Route>

      {/* auth routes */}
      <Route element={<AuthRoutes />}>
        <Route path="/logout" element={<Logout />} />

        <Route path="/" element={<MainLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="/users" element={<UserList />} />
          <Route path="/user/:id" element={<UserDetails />} />
          <Route path="/customers" element={<CustomerList />} />
          <Route path="/expenses" element={<ExpenseList />} />
          <Route path="/customer/:id" element={<CustomerDetails />} />
          <Route path="/stores" element={<StoreList />} />
          <Route
            path="/cash-denominations"
            element={<CashDenominationList />}
          />
          <Route path="/cash/:id" element={<CashDenominationDetails />} />
          <Route path="/stores/:id" element={<StoreDetails />} />
          <Route path="/suppliers" element={<SupplierList />} />
          <Route path="/supplier/:id" element={<SupplierDetails />} />
          <Route path="/tags" element={<TagList />} />
          <Route path="/tags/:id" element={<TagDetails />} />
          <Route path="/brands" element={<BrandList />} />
          <Route path="/brand/:id" element={<BrandDetails />} />
          <Route path="/attributes" element={<AttributeList />} />
          <Route path="/attribute/:id" element={<AttributeDetails />} />

          <Route path="/roles" element={<RoleList />} />

          <Route path="/products" element={<ProductList />} />
          <Route path="/product/:id" element={<ProductDetails />} />
          <Route path="/product-variants" element={<ProductVariantList />} />
          <Route path="/product-variant/:id" element={<VariantDetails />} />
          <Route path="/sales" element={<OrderList />} />
          <Route path="/sales-return" element={<SalesReturnList />} />
          <Route path="/invoice/:id" element={<InvoiceDetails />} />
          <Route path="/sales/:id" element={<OrderDetails />} />
          <Route path="/website-orders/:id" element={<WebsiteOrderDetails />} />

          <Route
            path="/stock-transactions"
            element={<StockTransactionList />}
          />
          <Route path="/damage-products" element={<DamageProductsList />} />
          <Route path="/system-logs" element={<ActivityLogs />} />
          <Route path="/stock-adjustment" element={<StockAdjustmentList />} />
          <Route
            path="/stock-adjustments/:id"
            element={<AdjustmentDetails />}
          />
          <Route path="/products" element={<ProductList />} />
          <Route path="/product/:id" element={<ProductDetails />} />
          <Route path="/product-variants" element={<ProductVariantList />} />
          <Route path="/product-variant/:id" element={<VariantDetails />} />
          <Route path="/orders" element={<OrderList />} />
          <Route path="/website-orders" element={<WebsiteOrderList />} />
          <Route path="/invoice/:id" element={<InvoiceDetails />} />
          <Route path="/payment-methods" element={<PaymentMethodsList />} />
          <Route path="/reasons" element={<ReasonList />} />
          <Route path="/order/:id" element={<OrderDetails />} />
          <Route path="/footfall" element={<CustomerReturnList />} />
          <Route path="/categories" element={<CategoryList />} />
          <Route path="/category/:id" element={<CategoryDetails />} />

          <Route
            path="/stock-transactions"
            element={<StockTransactionList />}
          />
          <Route path="/system-logs" element={<ActivityLogs />} />
          <Route
            path="/stock-adjustments/:id"
            element={<AdjustmentDetails />}
          />
          <Route path="/products" element={<ProductList />} />
          <Route path="/product/:id" element={<ProductDetails />} />
          <Route path="/product-variants" element={<ProductVariantList />} />
          <Route path="/product-variant/:id" element={<VariantDetails />} />
          <Route path="/orders" element={<OrderList />} />
          <Route path="/invoice/:id" element={<InvoiceDetails />} />
          <Route path="/payment-methods" element={<PaymentMethodsList />} />
          <Route path="/attribute-names" element={<AttributeNameList />} />
          <Route
            path="/currency-config"
            element={<DenominationSettingList />}
          />
          <Route path="/note-config" element={<CurrencyNoteList />} />
          <Route path="/reasons" element={<ReasonList />} />
          <Route path="/order/:id" element={<OrderDetails />} />
          <Route
            path="/stock-transactions"
            element={<StockTransactionList />}
          />
          <Route path="/stock-adjustment" element={<StockAdjustmentList />} />
          <Route
            path="/stock-adjustments/:id"
            element={<AdjustmentDetails />}
          />
          <Route path="/purchase" element={<PurchaseList />} />

          {/* reporting paths  */}
          <Route path="/sales-report" element={<SalesDashboard />} />
          <Route path="/products-report" element={<ProductDashboard />} />
          <Route path="/purchase" element={<PurchaseList />} />
          <Route path="/purchase/:id" element={<PurchaseDetails />} />

          <Route
            path="/inventory-configs"
            element={<InventoryConfigurationPage />}
          />
          <Route
            path="/inventory-configs"
            element={<InventoryConfigurationPage />}
          />
          <Route path="/website-config" element={<WebsiteConfig />} />
        </Route>
      </Route>

      <Route path="*" element={<NotFound />} />
    </Route>
  )
)
